export default __webpack_public_path__ + "static/media/sarjana.e9d837b0.svg";